import { render } from "./ProductsCase.vue?vue&type=template&id=69d9d20f&scoped=true"
import script from "./ProductsCase.vue?vue&type=script&lang=js"
export * from "./ProductsCase.vue?vue&type=script&lang=js"

import "./ProductsCase.vue?vue&type=style&index=0&id=69d9d20f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69d9d20f"]])

export default __exports__